import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import { FC, useRef } from 'react'
import { SearchExpertisesLUT } from '../../../services/web/types/responseWebServiceTypes'
import Typography from '@material-ui/core/Typography'
import useTranslate from '../../../i18n/useTranslate'
import { ButtonView } from '../../../control/button/button'
import AddIcon from '@material-ui/icons/Add'
import Button from '@material-ui/core/Button'
import { useHistory } from 'react-router-dom'
import { RoutePath } from '../../../router/routesConfig'
import { useExpertiseStyles } from './expertiseShareStyle'
import Dialog from '../../../control/dialog/dialog'
import useLoading from '../../../control/loading/useLoading'
import useExpertises from '../shareLogic/useExpertises'
import { useForm } from 'react-final-form'

const SearchExpertisesResults: FC<{ searchResult: SearchExpertisesLUT[] }> = ({ searchResult }) => {
    const classes = useExpertiseStyles()
    const translate = useTranslate()
    const history = useHistory()
    const dialogDeleteRef = useRef<Record<string, Function>>()
    const successRef = useRef<Record<string, Function>>()
    const inUsedRef = useRef<Record<string, Function>>()
    const idRef = useRef<number>()
    const loadingHook = useLoading()
    const expertiseHook = useExpertises()
    const form = useForm()

    const handleEdit = (id: number) => {
        /** EDIT */
        history.push(RoutePath.expertisesEdit.replace(':id', `${id}`))
    }

    const handleDelete = async () => {
        /** DELETE */
        dialogDeleteRef.current?.closeDialog()
        loadingHook.loadingOpen()
        if (idRef.current) {
            await expertiseHook.deleteExpertiseByID(idRef.current).then((data) => {
                if (data.status === 1) {
                    successRef.current?.openDialog()
                } else {
                    inUsedRef.current?.openDialog()
                }
            })
        }
        loadingHook.loadingClose()
    }

    const openConfirmDelete = (id: number) => {
        idRef.current = id
        dialogDeleteRef.current?.openDialog()
    }

    const handleAdd = () => {
        /** ADD */
        history.push(RoutePath.expertisesAdd)
    }

    const bindDeleteRef = (func: Record<string, Function>) => {
        dialogDeleteRef.current = { ...func }
    }

    const bindSuccessRef = (func: Record<string, Function>) => {
        successRef.current = { ...func }
    }

    const bindInUsedRef = (func: Record<string, Function>) => {
        inUsedRef.current = { ...func }
    }

    return (
        <>
            <Grid container justifyContent="space-between">
                <Grid item>
                    <Typography variant="h6">
                        {translate.get('LABEL.SEARCH_TOTAL_RESULT', [`${searchResult.length}`])}
                    </Typography>
                </Grid>
                <Grid item>
                    <Button size="large" variant="outlined" color="primary" onClick={handleAdd} startIcon={<AddIcon />}>
                        <Typography variant="button">{translate.get('BUTTON.ADD_EXPERTISE')}</Typography>
                    </Button>
                </Grid>
            </Grid>
            {searchResult.map((data: SearchExpertisesLUT) => (
                <Paper variant="outlined" className={classes.item} key={data.expertiseID}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item>
                            <ButtonView className={classes.btnEdit} onClick={() => handleEdit(data.expertiseID)}>
                                {translate.get('BUTTON.EDIT')}
                            </ButtonView>
                        </Grid>
                        <Grid item>
                            <ButtonView className={classes.btnDelete} onClick={() => openConfirmDelete(data.expertiseID)}>
                                {translate.get('BUTTON.DELETE')}
                            </ButtonView>
                        </Grid>

                        <Grid item xs="auto" style={{ paddingLeft: '32px' }}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography noWrap className={classes.header}>
                                        {translate.get('LABEL.EXPERTISE')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography>
                                        {translate.languageStore.currentLanguage === translate.languageKey.th
                                            ? data.expertiseNameTH
                                            : data.expertiseNameEN}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            ))}
            <Dialog
                onRef={bindSuccessRef}
                type="alert-message"
                title={translate.get('ALERT.TITLE.NOTIFICATION')}
                content={translate.get('ALERT.CONTENT.SAVE_SUCCESS')}
                onAfterClose={form.submit}
            />
            <Dialog
                onRef={bindInUsedRef}
                type="alert-message"
                title={translate.get('ALERT.TITLE.NOTIFICATION')}
                content={translate.get('MESSAGE.M026')}
            />
            <Dialog
                onRef={bindDeleteRef}
                type="alert-confirm"
                title={translate.get('ALERT.TITLE.WARNING')}
                content={translate.get('ALERT.CONTENT.NEED_TO_DELETE')}
                onClickConfirm={handleDelete}
            />
        </>
    )
}

export default SearchExpertisesResults
